﻿import React from 'react';
import scrollTo from 'scroll-to-element';

export function scrollToTop(duration = 100) {
    return new Promise(resolve => {
        scrollTo('header', {
            offset: 0,
            duration
        });

        setTimeout(resolve, duration);
    }); 
}

export function scrollToElement(el, duration = 100) {
    return new Promise(resolve => {
        scrollTo(el, {
            offset: 0,
            duration
        });

        setTimeout(resolve, duration);
    }); 
}

export function withScrollLink(WrappedComponent) {
    return class extends React.Component {
        scrollToEl = e => {
            e.preventDefault();
            scrollTo(this.props.to, { align: 'middle', duration: this.props.duration }); 
        };

        render() {
            return <WrappedComponent onClick={this.scrollToEl} {...this.props} />;
        }
    };
}